import { EntityMutationConfig } from '@/hooks/useEntityMutation';
import { ViatgersService } from '@/services/viatgers';

// Tipus bàsic per Viatger (simplificat)
export interface Viatger {
  id: string;
  nom: string;
  cognoms: string;
  reserva_id: string;
  [key: string]: any;
}

/**
 * Configuració per mutations de Viatger
 *
 * NOTA: Viatgers invaliden 3 query keys:
 * - ['viatgers'] - Llista general de viatgers
 * - ['reservation-guests'] - Viatgers per reserva
 * - ['mossos-viatgers'] - Taula editable de /mossos
 */
export const viatgerMutationConfig: EntityMutationConfig<Viatger> = {
  entity: 'viatger',
  service: ViatgersService,
  queryKey: ['viatgers'],
  additionalQueryKeys: [['reservation-guests'], ['mossos-viatgers']],
  messages: {
    createSuccess: 'Viatger creat correctament',
    updateSuccess: 'Viatger actualitzat correctament',
    deleteSuccess: 'Viatger eliminat correctament',
    createError: 'Error en crear el viatger',
    updateError: 'Error en actualitzar el viatger',
    deleteError: 'Error en eliminar el viatger',
  },
};
